import { Phone } from "lucide-react";
import { CONTACT } from "@/lib/menuData";

export const Header = () => {
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 w-full bg-[color:var(--brand-bg)] border-b-2 border-[color:var(--brand-ink)]"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="brand-logo"
          className="flex items-center gap-2"
        >
          <span className="inline-block bg-[color:var(--brand-red)] text-white font-display text-xl px-2.5 py-0.5 -rotate-3">
            EL
          </span>
          <span className="font-display text-xl sm:text-2xl tracking-tight">
            LOCO TACO
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8 font-medium">
          <a href="#menu" data-testid="nav-menu" className="hover:text-[color:var(--brand-red)] transition-colors">Menu</a>
          <a href="#hours" data-testid="nav-hours" className="hover:text-[color:var(--brand-red)] transition-colors">Hours</a>
          <a href="#catering" data-testid="nav-catering" className="hover:text-[color:var(--brand-red)] transition-colors">Catering</a>
          <a href="#visit" data-testid="nav-visit" className="hover:text-[color:var(--brand-red)] transition-colors">Visit</a>
        </nav>

        <a
          href={CONTACT.phones[0].href}
          data-testid="header-call-btn"
          className="btn-brutal inline-flex items-center gap-2 bg-[color:var(--brand-red)] text-white font-bold uppercase text-sm px-3 py-2 border-2 border-[color:var(--brand-ink)] shadow-brutal-sm"
        >
          <Phone size={16} strokeWidth={2.75} />
          <span className="hidden sm:inline">Call to Order</span>
          <span className="sm:hidden">Call</span>
        </a>
      </div>
    </header>
  );
};

export default Header;
